import {toast} from 'react-toastify';

const info = (message, options) => {
  toast.info(message, { ...options, containerId: 'toast' });
}

const success = (message, options) => {
  toast.success(message, { ...options, containerId: 'toast' });
}

const warn = (message, options) => {
  toast.warn(message, { ...options, containerId: 'toast' });
}

const error = (message, options) => {
  toast.error(message, { ...options, containerId: 'toast' });
}

const toaster = (message, options) => {
  toast(message, { ...options, type: 'default', containerId: 'toast' });
}

toaster.info = info;
toaster.success = success;
toaster.warn = warn;
toaster.error = error;

export default toaster;